(() => {
  const TOGGLE_ICON = `
    <svg viewBox="0 0 22 22" aria-hidden="true" focusable="false">
      <path d="M11.001 13.7268C10.8788 13.7268 10.7642 13.7077 10.6573 13.6695C10.5503 13.6313 10.451 13.5664 10.3594 13.4747L6.14271 9.25807C5.97465 9.09002 5.89062 8.87613 5.89062 8.61641C5.89062 8.35668 5.97465 8.1428 6.14271 7.97474C6.31076 7.80668 6.52465 7.72266 6.78438 7.72266C7.0441 7.72266 7.25799 7.80668 7.42604 7.97474L11.001 11.5497L14.576 7.97474C14.7441 7.80668 14.958 7.72266 15.2177 7.72266C15.4774 7.72266 15.6913 7.80668 15.8594 7.97474C16.0274 8.1428 16.1115 8.35668 16.1115 8.61641C16.1115 8.87613 16.0274 9.09002 15.8594 9.25807L11.6427 13.4747C11.551 13.5664 11.4517 13.6313 11.3448 13.6695C11.2378 13.7077 11.1233 13.7268 11.001 13.7268Z"></path>
    </svg>
  `;

  /* icon-close.svg */
  const CLOSE_ICON = `
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path d="M10.1365 12.2948L2.58229 19.849C2.29965 20.1316 1.93993 20.2729 1.50313 20.2729C1.06632 20.2729 0.706597 20.1316 0.423958 19.849C0.141319 19.5663 0 19.2066 0 18.7698C0 18.333 0.141319 17.9733 0.423958 17.6906L7.97812 10.1365L0.423958 2.58229C0.141319 2.29965 0 1.93993 0 1.50313C0 1.06632 0.141319 0.706597 0.423958 0.423958C0.706597 0.141319 1.06632 0 1.50313 0C1.93993 0 2.29965 0.141319 2.58229 0.423958L10.1365 7.97813L17.6906 0.423958C17.9733 0.141319 18.333 0 18.7698 0C19.2066 0 19.5663 0.141319 19.849 0.423958C20.1316 0.706597 20.2729 1.06632 20.2729 1.50313C20.2729 1.93993 20.1316 2.29965 19.849 2.58229L12.2948 10.1365L19.849 17.6906C20.1316 17.9733 20.2729 18.333 20.2729 18.7698C20.2729 19.2066 20.1316 19.5663 19.849 19.849C19.5663 20.1316 19.2066 20.2729 18.7698 20.2729C18.333 20.2729 17.9733 20.1316 17.6906 19.849L10.1365 12.2948Z" fill="currentColor"/>
    </svg>
  `;

  const ESSENTIAL_LABEL_MOBILE = 'Cookies obligatoires';
  const ESSENTIAL_LABEL_DESKTOP = 'Cookies strictement nécessaires';
  const DESKTOP_MEDIA_QUERY = '(min-width: 991px)';

  const updateEssentialCookiesLabel = () => {
    const label = document.querySelector('#shopify-pc__prefs__essential label');
    if (!label) return;

    const isDesktop = window.matchMedia(DESKTOP_MEDIA_QUERY).matches;

    for (const node of label.childNodes) {
      if (node.nodeType !== Node.TEXT_NODE) continue;

      const text = node.textContent;
      if (!text.includes(ESSENTIAL_LABEL_MOBILE) && !text.includes(ESSENTIAL_LABEL_DESKTOP)) {
        continue;
      }

      node.textContent = isDesktop
        ? text.replace(ESSENTIAL_LABEL_MOBILE, ESSENTIAL_LABEL_DESKTOP)
        : text.replace(ESSENTIAL_LABEL_DESKTOP, ESSENTIAL_LABEL_MOBILE);
      return;
    }
  };

  const updateEssentialCookiesStatus = () => {
    const switchSpan = document.querySelector(
      '#shopify-pc__prefs__essential label span[aria-hidden="true"]'
    );
    if (!switchSpan) return;

    switchSpan.querySelectorAll('svg').forEach((svg) => {
      if (svg.closest('.shopify-pc__prefs__toggle')) return;
      svg.remove();
    });

    const essentialStatusLabel = String(document.documentElement.lang || '')
      .trim()
      .toLowerCase()
      .startsWith('en')
      ? 'Still active'
      : 'Toujours actif';

    const statusNode = [...switchSpan.childNodes].find(
      (node) =>
        node.nodeType === Node.TEXT_NODE &&
        (node.textContent.includes('Toujours actif') || node.textContent.includes('Still active'))
    );

    if (statusNode) {
      if (!statusNode.textContent.includes(essentialStatusLabel)) {
        statusNode.textContent = statusNode.textContent.replace('Toujours actif', essentialStatusLabel);
      }
      return;
    }

    const toggle = switchSpan.querySelector('.shopify-pc__prefs__toggle');
    const textNode = document.createTextNode(essentialStatusLabel);

    if (toggle) {
      switchSpan.insertBefore(textNode, toggle);
    } else {
      switchSpan.appendChild(textNode);
    }
  };

  const enhanceCookiePreferenceDropdowns = () => {
    document.querySelectorAll('.shopify-pc__prefs__option').forEach((option) => {
      if (option.dataset.dropdownReady === 'true') return;

      const label = option.querySelector('label');
      const details = option.querySelector('p');
      if (!label || !details) return;

      const switchSpan = label.querySelector('span[aria-hidden="true"]');
      if (!switchSpan) return;

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'shopify-pc__prefs__toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Afficher les détails');
      toggle.innerHTML = TOGGLE_ICON;

      details.hidden = true;

      toggle.addEventListener('click', () => {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isExpanded));
        toggle.setAttribute('aria-label', isExpanded ? 'Afficher les détails' : 'Masquer les détails');
        details.hidden = isExpanded;
      });

      switchSpan.appendChild(toggle);
      option.dataset.dropdownReady = 'true';
    });
  };

  const replacePrefsHeaderCloseIcon = () => {
    document
      .querySelectorAll('.shopify-pc__prefs__header-close, #shopify-pc__prefs__header-close')
      .forEach((closeButton) => {
        if (closeButton.dataset.iconReplaced === 'true') return;

        closeButton.innerHTML = CLOSE_ICON.trim();
        closeButton.dataset.iconReplaced = 'true';
      });
  };

  const PREFS_ACCEPT_BUTTON_LABEL = String(document.documentElement.lang || '')
    .trim()
    .toLowerCase()
    .startsWith('en')
    ? 'Confirm selection'
    : 'Confirmer la sélection';

  const updatePrefsAcceptButtonLabel = () => {
    const acceptButton = document.getElementById('shopify-pc__prefs__header-accept');
    if (!acceptButton) return;
    if (acceptButton.textContent.trim() === PREFS_ACCEPT_BUTTON_LABEL) return;

    acceptButton.textContent = PREFS_ACCEPT_BUTTON_LABEL;
  };

  const moveCookiePrefsActions = () => {
    const dialog = document.querySelector('.shopify-pc__prefs__dialog');
    const actions = document.querySelector('.shopify-pc__prefs__header-actions');

    if (!dialog || !actions) return;
    if (actions.parentElement === dialog && dialog.lastElementChild === actions) return;

    dialog.appendChild(actions);
  };

  const unlockBodyScroll = () => {
    document.body.classList.remove(
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden-desktop'
    );

    if (document.body.style.overflow === 'hidden') {
      document.body.style.removeProperty('overflow');
    }

    if (document.documentElement.style.overflow === 'hidden') {
      document.documentElement.style.removeProperty('overflow');
    }
  };

  const scheduleUnlockBodyScroll = () => {
    unlockBodyScroll();
    window.requestAnimationFrame(unlockBodyScroll);
    window.setTimeout(unlockBodyScroll, 0);
    window.setTimeout(unlockBodyScroll, 120);
  };

  const syncCookieModalUi = () => {
    moveCookiePrefsActions();
    updateEssentialCookiesLabel();
    enhanceCookiePreferenceDropdowns();
    updateEssentialCookiesStatus();
    replacePrefsHeaderCloseIcon();
    updatePrefsAcceptButtonLabel();
  };

  const COOKIE_PREFERENCES_OPENER_SELECTOR = '[data-cookie-preferences-opener], .cookies-parameters';

  const openCookiePreferences = (event) => {
    event?.preventDefault?.();

    if (typeof window.privacyBanner?.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      scheduleUnlockBodyScroll();
      return;
    }

    document.querySelector('.shopify-pc__banner__btn-manage-prefs')?.click();
    scheduleUnlockBodyScroll();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest(COOKIE_PREFERENCES_OPENER_SELECTOR);
    if (opener) {
      openCookiePreferences(event);
      return;
    }

    if (event.target.closest('.shopify-pc__banner__btn-manage-prefs')) {
      scheduleUnlockBodyScroll();
    }
  });

  document.addEventListener('DOMContentLoaded', syncCookieModalUi);
  window.matchMedia(DESKTOP_MEDIA_QUERY).addEventListener('change', updateEssentialCookiesLabel);
  const observer = new MutationObserver(syncCookieModalUi);
  observer.observe(document.body, { childList: true, subtree: true });
})();
